import React, { useState, useEffect } from 'react';

import { Castle } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { 
  Character
} from "@dndModels";

import CharacterBastionInput from "@dndComponents/character/bastions/CharacterBastionInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  character: Character;
  recalc_time: number;
  disabled: boolean;
}

export default function CharacterBastionButton({
  character,
  recalc_time,
  disabled,
}: Props) {
  // const [flashing, setFlashing] = useState((
  //   character.gifts.filter(o => 
  //     o.needs_attention).length > 0 || 
  //   character.extra_feats.filter(o => 
  //     o.needs_attention).length > 0
  // ));
  const [open, setOpen] = useState(false);
  const [prev_recalc_time, setRecalcTime] = useState(recalc_time);
  
  useEffect(() => {
    if (recalc_time !== prev_recalc_time) {
      setRecalcTime(recalc_time);
      // if (character.gifts.filter(o => o.needs_attention).length > 0) {
      //   if (!flashing) {
      //     setFlashing(true);
      //   }
      // } else if (flashing) {
      //   setFlashing(false);
      // }
    }
    // eslint-disable-next-line
  }, [recalc_time]);

  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    return (
      <ModalOrDrawer 
        open={ open } 
        width={ wide_mode ? 800 : undefined }
        full_page
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <Grid container spacing={0} direction="row" 
            style={{ maxHeight: window.innerHeight - 34 }}>
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterBastionInput
                char={character}
              />
            </Grid>
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Tooltip title="Bastions">
        <Castle
          className="clickable"
          onClick={() => {
            if (!disabled) {
              setOpen(true);
            }
          }}
        />
      </Tooltip>
      { renderExtras() }
    </>
  ); 
}
